import { render, staticRenderFns } from "./ChatAgentWidget.vue?vue&type=template&id=2db0e3fb&scoped=true"
import script from "./ChatAgentWidget.vue?vue&type=script&lang=js"
export * from "./ChatAgentWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatAgentWidget.vue?vue&type=style&index=0&id=2db0e3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0e3fb",
  null
  
)

export default component.exports